$(function () {
    if ($('.component-section-navigation').length) {
        var page = $('body').prop('id');
        if (typeof page === 'string' && page.length > 0) {
            $('.component-section-navigation').find('.' + page).addClass('active');
        }
    }
});